import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchUtilisateurs = createAsyncThunk(
  'utilisateurs/fetch',
  async (params = {}) => {
    const { data } = await api.get('/utilisateurs/', { params });
    return data;
  }
);

export const createUtilisateur = createAsyncThunk(
  'utilisateurs/create',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post('/utilisateurs/', payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response?.data || {});
    }
  }
);

export const updateUtilisateur = createAsyncThunk(
  'utilisateurs/update',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const { data } = await api.patch(`/utilisateurs/${id}/`, payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response?.data || {});
    }
  }
);

export const supprimerUtilisateur = createAsyncThunk(
  'utilisateurs/supprimer',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/utilisateurs/${id}/`);
      return { id, message: data.message };
    } catch (e) {
      return rejectWithValue(e.response?.data || {});
    }
  }
);

export const suspendreUtilisateur = createAsyncThunk(
  'utilisateurs/suspendre',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/utilisateurs/${id}/suspendre/`);
      return { id, message: data.message };
    } catch (e) {
      return rejectWithValue(e.response?.data || {});
    }
  }
);

export const activerUtilisateur = createAsyncThunk(
  'utilisateurs/activer',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/utilisateurs/${id}/activer/`);
      return { id, message: data.message };
    } catch (e) {
      return rejectWithValue(e.response?.data || {});
    }
  }
);

export const reinitialiserMdp = createAsyncThunk(
  'utilisateurs/reinitialiserMdp',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/utilisateurs/${id}/reinitialiser-mdp/`);
      return data; // { message, nouveau_mdp }
    } catch (e) {
      return rejectWithValue(e.response?.data || {});
    }
  }
);

const utilisateursSlice = createSlice({
  name: 'utilisateurs',
  initialState: {
    liste:      [],
    loading:    false,
    error:      null,
  },
  reducers: {},
  extraReducers: (b) => {
    b
      .addCase(fetchUtilisateurs.pending,   (s) => { s.loading = true; s.error = null; })
      .addCase(fetchUtilisateurs.fulfilled, (s, { payload }) => {
        s.loading = false;
        s.liste   = payload.results ?? payload;
      })
      .addCase(fetchUtilisateurs.rejected,  (s, { error }) => { s.loading = false; s.error = error.message; });
  },
});

export default utilisateursSlice.reducer;
